<template>
    <el-dialog title="Оформление доп продукта" :visible.sync="visibleModalModel" width="400px" :append-to-body="true" v-loading="isLoading">
        <AffiliateSaleForm v-if="affiliate_sale" mode="create" @saved="onSaved" :sale="affiliate_sale"  />
    </el-dialog>
</template>

<script>

import AffiliateSaleForm from "./AffiliateSaleForm";
export default {
    name: "ModalEdit",
    components: {AffiliateSaleForm},
    props: ['visibleModal', 'dealId'],
    data: () => ({
        isLoading: false,
        affiliate_sale: null,
    }),
    mounted() {
        this.fetch();
    },
    computed: {
        visibleModalModel: {
            get () { return this.visibleModal },
            set (value) { this.$emit('update:visibleModal', value) },
        },
    },
    methods: {
        onSaved() {
            this.visibleModalModel = false;
            this.$emit('saved');
        },
        fetch() {
            this.isLoading = true;
            axios.get('/api/deals/' + this.dealId)
                .then(res => {
                    this.affiliate_sale = {
                        deal_id: this.dealId,
                        status: 1,
                        platform_id: res.data.platform_id,
                    }
                    this.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
